import React from 'react';
import { Provider } from 'react-redux';
import { AppRouter } from './routers/AppRouter';
import { store } from './store/store';

import 'rsuite/dist/styles/rsuite-default.css'; 
import './css/dark_theme.css';
import './css/connect.css';
import './css/custom.css';

if(localStorage.getItem('theme') === 'dark'){
  document.getElementsByTagName('body')[0].classList.add('dark-theme');
}

const App = () => {

  return (
    <Provider store={store}>
          <AppRouter />
          {/* <ToastContainer /> */}
    </Provider>
  );
}

export default App;
